import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const partnerListApi = createAsyncThunk(
    "partnerList",
    async () => {
        const response = await axiosInstance.get("/partnerList");
        return response.data;
    }
);

const partnerListSlice = createSlice({
    name: "partnerList",
    initialState: {
        partnerList: [],
        errors: [],
        loading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(partnerListApi.pending, (state) => {
                state.loading = true;
            })
            .addCase(partnerListApi.fulfilled, (state, action) => {
                state.partnerList = action.payload;
                state.loading = false;
            })
            .addCase(partnerListApi.rejected, (state, action) => {
                state.errors.push(action.error.message);
                state.loading = false;
            });
    },
});

export default partnerListSlice.reducer;

